import de from "./de";
import pl from "./pl";
import en from "./en";
export default {
  de,
  pl,
  en
};
